import { Badge, Box, styled } from '@mui/material';

const TOGGLE_GROUP_HEIGHT = 48;
const TOGGLE_BUTTON_HEIGHT = 40;
const TOGGLE_RADIUS = 100;
const TOGGLE_HORIZONTAL_PADDING = 12;
const TOGGLE_CONTENT_GAP = 8;
const TOGGLE_ICON_SIZE = 16;
const TOGGLE_LETTER_SPACING = '0.32px';
const NAVY = '#061e44';
const UNSELECTED_BORDER = '#999';
const WHITE = '#ffffff';
const BADGE_BACKGROUND = '#0f48b8';
const BADGE_MIN_WIDTH = 16;
const BADGE_MAX_WIDTH = 34;
const BADGE_MIN_HEIGHT = 19;
const BADGE_HORIZONTAL_PADDING = 4;

const selectedToggleStyles = {
  backgroundColor: `${NAVY} !important`,
  borderColor: NAVY,
  color: WHITE,

  '&:hover': {
    backgroundColor: `${NAVY} !important`,
    color: WHITE,
  },

  '& .MuiSvgIcon-root': {
    color: WHITE,
  },
};

/**
 * The count sits beside the Active label instead of floating over it, so the badge is
 * positioned statically rather than with MUI's default overlay transform.
 */
export const SectionCountBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    position: 'static',
    transform: 'none',
    boxSizing: 'border-box',
    minWidth: BADGE_MIN_WIDTH,
    maxWidth: BADGE_MAX_WIDTH,
    minHeight: BADGE_MIN_HEIGHT,
    padding: `0 ${BADGE_HORIZONTAL_PADDING}px`,
    marginLeft: theme.spacing(1),
    borderRadius: TOGGLE_RADIUS,
    backgroundColor: BADGE_BACKGROUND,
    color: WHITE,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: `${BADGE_MIN_HEIGHT}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

/**
 * Two-segment pill sized for Active/Archived. Feeds Audit styles are not reused here —
 * those buttons are wider than this control. v4 ToggleButton uses
 * `.MuiToggleButton-selected`; `.Mui-selected` is included for the v5 state class.
 */
export const SectionToggleGroup = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: TOGGLE_GROUP_HEIGHT,

  '& .MuiToggleButtonGroup-root': {
    height: TOGGLE_BUTTON_HEIGHT,
    borderRadius: TOGGLE_RADIUS,
  },

  '& .MuiToggleButton-root': {
    height: TOGGLE_BUTTON_HEIGHT,
    padding: `0 ${TOGGLE_HORIZONTAL_PADDING}px`,
    borderColor: UNSELECTED_BORDER,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: WHITE,
    color: NAVY,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: TOGGLE_LETTER_SPACING,
    lineHeight: 1,
    textTransform: 'none',

    '& .MuiToggleButton-label': {
      display: 'flex',
      alignItems: 'center',
      gap: TOGGLE_CONTENT_GAP,
    },

    '& .MuiSvgIcon-root': {
      fontSize: TOGGLE_ICON_SIZE,
      color: 'inherit',
    },

    '&.MuiToggleButton-selected': selectedToggleStyles,
    '&.Mui-selected': selectedToggleStyles,
  },

  // Re-apply v4 grouped-horizontal seam after our border so the join is one #999 edge.
  '& .MuiToggleButtonGroup-groupedHorizontal:not(:first-child)': {
    marginLeft: -1,
    borderLeft: '1px solid transparent',
  },

  '& .toggle-button-left': {
    borderTopLeftRadius: TOGGLE_RADIUS,
    borderBottomLeftRadius: TOGGLE_RADIUS,
  },

  '& .toggle-button-right': {
    borderTopRightRadius: TOGGLE_RADIUS,
    borderBottomRightRadius: TOGGLE_RADIUS,
  },
}));
